import {BasicScenario} from '../../framework/parameters/BasicScenario';

export class ProfileScenario extends BasicScenario {
manageRoles: boolean | null;
}

